/**
 * Auto-calculation formulas for pulse entry fields.
 * Extracted from PulseEntry.js to be reusable by both single-entry and bulk-entry modes.
 * All formulas MUST match PulseEntry.js behavior exactly.
 */

/**
 * Calculate derived metrics from a row of pulse entry data.
 * @param {Object} rowData - The row form data with string values
 * @returns {{ connectPct: number, scheduleRate: number, visitDoneRate: number, totalClosure: number, closureRate: number }}
 */
export function calculateRowMetrics(rowData) {
  if (!rowData) {
    return { connectPct: 0, scheduleRate: 0, visitDoneRate: 0, totalClosure: 0, closureRate: 0 };
  }

  const dialed = parseInt(rowData.dialed) || 0;
  const connected = parseInt(rowData.connected) || 0;
  const scheduled = parseInt(rowData.visit_scheduled) || 0;
  const done = parseInt(rowData.visit_done) || 0;
  const closurePhone = parseInt(rowData.closure_phone) || 0;
  const closureCounter = parseInt(rowData.closure_counter) || 0;
  const closureExpected = parseInt(rowData.closure_expected) || 0;

  const connectPct = dialed > 0 ? Math.round((connected / dialed) * 100) : 0;
  const scheduleRate = connected > 0 ? Math.round((scheduled / connected) * 100) : 0;
  const visitDoneRate = scheduled > 0 ? Math.round((done / scheduled) * 100) : 0;
  const totalClosure = closurePhone + closureCounter;
  const closureRate = closureExpected > 0 ? Math.round((totalClosure / closureExpected) * 100) : 0;

  return { connectPct, scheduleRate, visitDoneRate, totalClosure, closureRate };
}

/**
 * Get CSS color string for connect percentage display.
 * Matches PulseEntry.js getConnectColor function exactly:
 *   >= 70 -> green
 *   >= 60 -> yellow/warning
 *   < 60  -> red
 * @param {number} pct - Connect percentage (0-100+)
 * @returns {string} CSS color string
 */
export function getConnectColor(pct) {
  if (pct >= 70) return '#28A745';
  if (pct >= 60) return '#FFC107';
  return '#DC3545';
}
